import styles from './AccessGate.module.css';

type Props = {
  title?: string;
  message: string;
  subscribeUrl: string;
  onRetry?: () => void;
};

export function AccessGate({
  title = 'Playhub access needed',
  message,
  subscribeUrl,
  onRetry,
}: Props) {
  return (
    <div className={styles.wrap} role="dialog" aria-labelledby="nganya-access-title">
      <div className={styles.card}>
        <p className={styles.kicker}>Nganya</p>
        <h1 id="nganya-access-title" className={styles.title}>
          {title}
        </h1>
        <p className={styles.lead}>{message}</p>
        <div className={styles.actions}>
          <a className={styles.primary} href={subscribeUrl}>
            Subscribe on Playhub
          </a>
          {onRetry ? (
            <button type="button" className={styles.secondary} onClick={onRetry}>
              Try again
            </button>
          ) : null}
        </div>
      </div>
    </div>
  );
}
